'use client';
import React from 'react';

const ErrorBanner = ({
  message,
  backgroundColor,
}: {
  message: string;
  backgroundColor: string;
}) => {
  const bannerStyle = {
    backgroundColor: '#f44336',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '5px',
    textAlign: 'center' as any,
    fontWeight: 'bold',
    margin: '2px 0',
  };
  bannerStyle['backgroundColor'] = backgroundColor;
  return <div style={bannerStyle}>{message || 'An error occurred. Please try again.'}</div>;
};

export default ErrorBanner;
